import axios from 'axios';
import { toast } from 'react-hot-toast';

import { apiUrl } from '../apiUrl';
import { fetchSummerplayTypes } from './summerplayModel';

export const fetchAcademyTypes = async () => {
  // might be other later
  return await fetchSummerplayTypes();
};

export const fetchAcademy = async ({ franchiseId }) => {
  try {
    const response = await axios.get(
      `${apiUrl}/newSummerplay/${franchiseId}/academy_groups`,
    );

    return response.data.summerplay_groups || [];
  } catch (error) {
    toast.error(
      'Wystąpił problem pobierając grupy półkolonii. Odśwież aplikację.',
    );

    return [];
  }
};
